module.exports = __webpack_public_path__ + "img/bellow.d2dd3f93.svg";